import Conexion from "@/utils/Conexion.js"

export default ({
  path: process.env.NODE_ENV === 'development'
    ? 'http://localhost/public'
    // ? 'https://erick1.seifdesarrollo.com/public'   // Ngrok API SLIM8
    : Conexion.onGetUrlBase(),
  sApiKeyMap: "AIzaSyAsGgRnC34wiGutlNDOOhb83VzdlZzr1i4"
})
